import React from 'react';
import { Clock, LogOut } from 'lucide-react';
import { supabase } from '../services/supabase';

const WaitingApproval = ({ onLogout, t }) => {
    const handleLogout = async () => {
        await supabase.auth.signOut();
        if (onLogout) onLogout();
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: t.bg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            backgroundImage: 'linear-gradient(135deg, var(--bg) 0%, var(--bg-card) 100%)'
        }}>
            <div style={{
                maxWidth: 400,
                width: '100%',
                background: t.bgCard,
                borderRadius: 2,
                border: `1.5px solid ${t.ink}`,
                padding: 40,
                position: 'relative',
                textAlign: 'center'
            }}>
                <div style={{
                    width: 64, height: 64,
                    borderRadius: '50%',
                    background: `${t.accent}15`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 24px',
                    border: `1px solid ${t.accent}30`
                }}>
                    <Clock size={32} color={t.accent} />
                </div>

                <h2 style={{ fontFamily: t.disp, fontSize: 24, fontWeight: 700, color: t.text, margin: '0 0 12px 0', letterSpacing: '-0.02em' }}>
                    Acesso em Análise
                </h2>

                <p style={{ fontSize: 14, color: t.textSecondary, marginBottom: 32, lineHeight: 1.6 }}>
                    Sua conta está em fase de validação. Para empresas convidadas, o acesso é liberado após a verificação do vínculo. Para novos usuários, o time Prexo realiza uma análise de segurança em até 24h úteis.
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    <div style={{
                        padding: '12px 16px',
                        background: t.bgInput,
                        border: `1.5px solid ${t.ink}`,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                        textAlign: 'left'
                    }}>
                        <div style={{ width: 8, height: 8, borderRadius: '50%', background: t.profit, animation: 'pulse 2s infinite' }} />
                        <span style={{ fontFamily: t.mono, fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: t.textSecondary }}>Aguardando Aprovação</span>
                    </div>

                    <button
                        onClick={handleLogout}
                        style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                            padding: '12px 16px', borderRadius: 0,
                            border: `1.5px solid ${t.ink}`, background: t.bgCard,
                            color: t.text, fontFamily: t.mono, fontSize: 12, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: 'pointer',
                            marginTop: 12, transition: 'all 0.2s'
                        }}
                    >
                        <LogOut size={15} />
                        Sair da Conta
                    </button>
                </div>

                <div className="px-barcode" style={{ margin: '36px auto 6px', height: 22 }} />
                <p style={{ fontFamily: t.mono, fontSize: 9.5, color: t.textMuted, marginTop: 0, textTransform: 'uppercase', letterSpacing: '0.14em' }}>
                    Prexo · sistema de precisão
                </p>
            </div>
        </div>
    );
};

export default WaitingApproval;
